import Login from "../../components/Auth/Login";
import React from "react";


function LoginPage() {
  return (
    <div>
      <div className="login-wrapper">
        <div className="leftside">
          <Login />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
